import {
  SET_ACTIVE_PROJECT_SECTION,
  SET_ACTIVE_PROJECT,
  SET_ACTIVE_PROJECT_CONDITIONS
} from './projectActions';

import experimentalDesignReducer from './experimentalDesign/reducer';
import fileImportReducer from './fileImport/reducer';
import booking from './booking/reducer';

const appInitialState = { section: null, active: null };

const singleReducer = (state = appInitialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_PROJECT_SECTION:
      return { ...state, section: action.section };
    case SET_ACTIVE_PROJECT:
      return { ...state, active: action.active };
    case SET_ACTIVE_PROJECT_CONDITIONS:
      return { ...state, conditions: action.conditions };

    default:
      return {
        ...state,
        experimentalDesign: experimentalDesignReducer(state.experimentalDesign, action),
        fileImport: fileImportReducer(state.fileImport, action),
        booking: booking(state.booking, action)
      };
  }
};

export default singleReducer;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/reducer.js